/**
 * @file 公用接口
 * @author jiangjun
 */

import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 获取用户信息
 *
 * @return {Promise}
 */
export const userInfo = (params) => postWithJson(`/info.json`, params)

/**
 * 获取地域信息
 *
 * @param {number=} params.areaId 区域id，没有areaId表示取所有省的数据
 *
 * @return {Promise}
 */
export const areaSearch = (params) => postWithJson(`/area/children.json`, params)

/**
 * 获取枚举信息
 *
 * @return {Promise}
 */
export const enumList = (params) => postWithJson('/enumList.json', params)

/**
 * 部门类型
 *
 * @return {Promise}
 */
export const getDeptTypeList = (params) => postWithJson(`/dept/typeList.json`, params)

/**
 * 部门级别
 *
 * @return {Promise}
 */
export const getDeptLevelList = (params) => postWithJson(`/dept/levelList.json`, params)

export const getDeptGradeList = (params) => postWithJson(`/dept/gradeList.json`, params)

/**
 * 分公司列表
 *
 * @param {String} params.name 公司名称
 * @param {Object} params.pageDto 分页信息
 *
 * @return {Promise}
 */
export const getCompanyList = (params = { pageDto: { pageSize: 1000 }}) => postWithJson(`/company/list.json`, params)

/**
 * 获取日历模板列表
 *
 * @return {Promise}
 */
export const getCalendarTempList = (params) => postWithJson(`/calendar/tempList.json`, params)

/**
 * 事业部列表
 *
 * @return {Promise}
 */
export const getBusinessUnitList = (params) => postWithJson(`/common/getBusinessUnit.json`, params)